<template>
  <el-form
    :model="form"
    ref="form">
    <div class="row form-defalt-row">
      <div class="col-xl-3 col-md-6 col-12">
        <el-form-item
          :label="L10n('title')"
          prop="title"
          :rules="getValidationRule('required,minLength')"
          class="material-style">
          <el-input
            ref="firstField"
            :value="form.title"
            @input="form.title = valueTrimLeft($event)"
            @change="updateModelItem('title', { required: true })"/>
        </el-form-item>
      </div>
      <div class="col-xl-3 col-md-6 col-12">
        <el-form-item
          :label="L10n('slogan')"
          prop="slogan"
          class="material-style">
          <el-input
            :value="form.slogan"
            @input="form.slogan = valueTrimLeft($event)"
            @change="updateModelItem('slogan', { required: false })"/>
        </el-form-item>
      </div>
      <div class="col-xl-3 col-md-6 col-12">
        <el-form-item
          :label="L10n('version')"
          prop="version"
          :rules="getValidationRule('required,minLength')"
          class="material-style">
          <el-input
            :value="form.version"
            @input="form.version = valueTrimLeft($event)"
            @change="updateModelItem('version', { required: true })"/>
        </el-form-item>
      </div>
      <div class="col-xl-3 col-md-6 col-12">
        <el-form-item
          :label="L10n('copyrights')"
          prop="copyrights"
          class="material-style">
          <el-input
            :value="form.copyrights"
            @input="form.copyrights = valueTrimLeft($event)"
            @change="updateModelItem('copyrights', { required: false })"/>
        </el-form-item>
      </div>
    </div>
    <div class="row">
      <div class="col-md-6 col-12">
        <el-form-item
          :label="L10n('sub-title')"
          prop="subTitle"
          class="material-style">
          <skill-editor
            :model.sync="form.subTitle"
            @blur="updateModelItem('subTitle', { required: false })"
          />
        </el-form-item>
      </div>
      <div class="col-md-6 col-12">
        <el-form-item
          :label="L10n('description')"
          prop="description"
          class="material-style">
          <skill-editor
            :model.sync="form.description"
            @blur="updateModelItem('description', { required: false })"
          />
        </el-form-item>
      </div>
    </div>
    <div class="row">
      <div class="col-md-6 col-12">
        <el-form-item
          :label="L10n('bax-bank-details')"
          prop="baxBankDetails"
          class="material-style">
          <skill-editor
            :model.sync="form.baxBankDetails"
            @blur="updateModelItem('baxBankDetails', { required: false })"
          />
        </el-form-item>
      </div>
      <div class="col-md-6 col-12">
        <el-form-item
          :label="L10n('bax-technics-details')"
          prop="baxTechnicsDetails"
          class="material-style">
          <skill-editor
            :model.sync="form.baxTechnicsDetails"
            @blur="updateModelItem('baxTechnicsDetails', { required: false })"
          />
        </el-form-item>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <el-form-item
          :label="L10n('invoice-terms-and-conditions')"
          prop="invoiceTermsAndConditions"
          class="material-style"
        >
          <skill-editor
            :model.sync="form.invoiceTermsAndConditions"
            @blur="updateModelItem('invoiceTermsAndConditions', { required: false })"
          />
        </el-form-item>
      </div>
    </div>
  </el-form>
</template>

<script>
import Form from '@/components/Form/Form'

export default {
  name: 'FormLabel',
  mixins: [Form],
  components: {
    'skill-editor': () => import(/* webpackChunkName: 'Forms' */ '@/components/Form/SkillEditor')
  }
}
</script>
